import { supabase } from './supabaseClient'

export async function markMessagesAsRead(orderId: string, userId: string) {
  await supabase
    .from('messages')
    .update({ read_at: new Date().toISOString() })
    .eq('order_id', orderId)
    .neq('sender_id', userId)
    .is('read_at', null)
}

/**
 * Retourne le nombre de messages non lus par commande (côté CLIENT).
 * Un message est non lu si :
 *  - envoyé par ADMIN
 *  - read_at IS NULL
 */

export async function getUnreadCount(
  orderIds: string[],
  viewerRole: 'USER' | 'ADMIN' | 'PARTNER'
): Promise<Record<string, number>> {
  if (orderIds.length === 0) return {}

  const otherRole = viewerRole === 'ADMIN' ? 'USER' : 'ADMIN'

  // Dernier message envoyé par MOI, par commande
  const { data: lastMine } = await supabase
    .from('messages')
    .select('order_id, created_at')
    .in('order_id', orderIds)
    .eq('sender_role', viewerRole)

  const lastByOrder: Record<string, string> = {}
  lastMine?.forEach(m => {
    if (!lastByOrder[m.order_id] || m.created_at > lastByOrder[m.order_id]) {
      lastByOrder[m.order_id] = m.created_at
    }
  })

  // Messages envoyés par l'AUTRE
  const { data: others } = await supabase
    .from('messages')
    .select('order_id, created_at')
    .in('order_id', orderIds)
    .eq('sender_role', otherRole)
    .is('read_at', null)

  const result: Record<string, number> = {}

  for (const msg of others ?? []) {
    const lastReadAt = lastByOrder[msg.order_id]
    if (!lastReadAt || msg.created_at > lastReadAt) {
      result[msg.order_id] = (result[msg.order_id] ?? 0) + 1
    }
  }

  return result
}
